import React, {ReactNode, Ref} from 'react';

export interface IModuleLinksProps {
	ref?: Ref<HTMLDivElement>;
	className?: string;
	children: ReactNode;
	style?: React.CSSProperties;
	variant?: ModuleLinksStyleColor;
}

export enum ModuleLinksStyleColor {
	WHITE = 'white',
	BLACK = 'black',
}